class Geolocation {
  /**
   * Creates a new Geolocation
   */
  constructor() {
    this.COOKIE_NAME_MARKET = 'expected_market';
    this.COOKIE_NAME_CHOICE = 'market_change';
    this.COOKIE_AGE_DAYS = 30;

    this.geolocate();
  }

  /**
   * Sets the cookie used for automatic redirection
   * 
   * @param {string} value
   * @returns {void}
   */
  setCookie(name, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (this.COOKIE_AGE_DAYS * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + ";domain=.sigvaris.com;Path=/; SameSite=Lax";
  }

  /**
   * Retrieves the cookie used for automatic redirection 
   * 
   * @returns {string}
   */
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
  }

  /**
   * Removes a cookie
   * 
   * @returns {void}
   */
  destroyCookie(name) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() - 1000);
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + "" + expires + ";domain=.sigvaris.com;Path=/; SameSite=Lax";
    document.cookie = name + "=" + "" + expires + ";Path=/; SameSite=Lax";
  }

  /**
   * Retrieves the current market based on current URL.
   * Returns an empty string if no current market.
   * 
   * @returns {string}
   */
  getCurrentMarket() {
    var path = window.location.pathname;
    var parts = path.split('/');
    // parts[1] is the locale segment if it exists.
    // it assumes it's in a xx-xx format only.
    if (parts.length > 1 && /^[a-z]{2}-[a-z]{2}$/i.test(parts[1])) {
      return parts[1].toLowerCase();
    }
    return null;
  }

  /**
   * Redirects the user to the desired market.
   * 
   * @param {string} market
   * @returns {void}
   */
  redirectToMarket(market) {
    if (!market) return;

    var currentMarket = this.getCurrentMarket();
    if (!currentMarket) {
      // Currently without a market
      window.location.href = "/" + market + window.location.pathname + window.location.search + window.location.hash;
    } else {
      // Replace the locale prefix with the expected one
      var newPathname = window.location.pathname.replace("/" + currentMarket, "/" + market);
      window.location.href = newPathname + window.location.search + window.location.hash;
    }
  }

  /**
   * Detects if the user manually navigated to a different market
   * by checking the Navigation Timing API
   * 
   * @returns {void}
   */
  isManualNavigation() {
    var perfData = performance.getEntriesByType('navigation')[0];
    if (!perfData) return false;

    // Check if it's a typed URL or link click AND there was no server redirect
    return (perfData.type === 'navigate' || perfData.type === 'back_forward')
      && (perfData.redirectCount === 0 || perfData.redirectCount === 2);
  }

  /**
   * Decides if the user should be automatically redirected.
   * 
   * @returns {void}
   */
  geolocate() {
    var currentMarket = this.getCurrentMarket();
    var expectedMarket = this.getCookie(this.COOKIE_NAME_MARKET);

    console.log("currentMarket", currentMarket);
    console.log("expectedMarket", expectedMarket);

    // We fully overwrite everything because user changed market himself.
    var overwrite = this.getCookie(this.COOKIE_NAME_CHOICE);
    if (overwrite) {
      console.log("overwrite", overwrite);
      this.destroyCookie(this.COOKIE_NAME_CHOICE);
      this.setCookie(this.COOKIE_NAME_MARKET, currentMarket);
      return;
    }

    // User manually navigated, we accept the new market
    if (this.isManualNavigation()) {
      console.log("is manual navigation");
      this.setCookie(this.COOKIE_NAME_MARKET, currentMarket);
      return;
    }

    // First visit with no cookie, we trust Shopify's choice
    if (!expectedMarket && currentMarket) {
      console.log("first visit with no cookie");
      this.setCookie(this.COOKIE_NAME_MARKET, currentMarket);
      return;
    }

    // User has a cookie but is not on the correct market, we redirect
    if (expectedMarket && currentMarket && expectedMarket !== currentMarket) {
      console.log("user in wrong market, redirecting");
      this.redirectToMarket(expectedMarket);
      return;
    }

    // User is on "/" (no locale) and Shopify routed incorrectly, we redirect
    if (expectedMarket && !currentMarket) {
      console.log("user is on / in wrong market, redirecting");
      this.redirectToMarket(expectedMarket);
      return;
    }

  }
}

const geolocation = new Geolocation();